import React, { useEffect, useRef, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";
import Menu from "./Menu";

const testimonials = [
  {
    name: "CS SURENDRA SACHDEVA, KOLKATA",
    designation: "",
    feedback:
      "Priya Aggarwal has very ably handled the task of getting approval from the MCA for my shares which were transferred to IEPF.  She remained regularly in touch with the Registrars to the Company and concerned company officials as a result of which, all steps at the end of the company were completed at jet speed. Regular follow ups with the MCA and what was most satisfying, is giving feedback on the progress of the case to me at periodicals .  Kudos to Priya !",
  },
  {
    name: "HUZAIFA TOPIWALA, PUNE",
    designation: "",
    feedback:
      "I had a seamless experience with GetMyShares in handling the transmission of my late father's shares of SRF Ltd to my mother’s name. Their team was incredibly supportive and handled our case with great ease. The process was hassle-free, and their expertise ensured smooth documentation and timely execution. I highly recommend GetMyShares to anyone seeking professional and reliable assistance in share transfers!",
  },
  {
    name: "MOHAMMAD TARIQ, SYDNEY AUSTRALIA",
    designation: "",
    feedback:
      "I was facing significant challenges in recovering my shares of Reliance Industries and Eicher Motors as an NRI, but GetMyShare made the entire process seamless and hassle-free. Their expertise and dedication ensured that my shares were recovered in record time, far beyond my expectations. The professionalism, transparency, and commitment they showed throughout the process were truly commendable. I wholeheartedly recommend GetMyShare for assistance in reclaiming their shares from IEPF. Thank you for your exceptional service!",
  },

];

const Testimonial: React.FC = () => {
  const contentContainerRef = useRef<HTMLDivElement | null>(null);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (contentContainerRef.current) {
        const contentRect = contentContainerRef.current.getBoundingClientRect();
        setIsSticky(contentRect.top <= 0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div ref={contentContainerRef}>
      {/* Static Banner Section */}
      <Box
        sx={{
          width: "100%",
          height: "20vh",
          position: "relative",
          overflow: "hidden",
          background: `
            linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.7)), 
            url(${"/assets/service_01.jpg"})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Menu isSticky={isSticky} />
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "#fff",
            textAlign: "center",
          }}
        >
        </Box>
      </Box>

      {/* Testimonials Content Section */}
      <Box
        sx={{
          padding: "60px 20px",
          backgroundColor: "#000000", // Black background
          textAlign: "center",
        }}
      >
        {/* Header */}
        <Typography
          variant="h4"
          sx={{
            fontWeight: "bold",
            fontFamily: "'Poppins', sans-serif",
            marginBottom: "10px",
            color: "#FFFFFF",
          }}
        >
          What they say{" "}
          <Typography
            component="span"
            sx={{
              color: "#8BC34A",
            }}
          >
            about us
          </Typography>
        </Typography>

        <Typography
          variant="subtitle1"
          sx={{
            color: "#FFFFFF",
            fontFamily: "'Poppins', sans-serif",
            marginBottom: "40px",
          }}
        >
          TESTIMONIALS FROM OUR HAPPY CLIENTS
        </Typography>

        {/* Testimonials - Now Vertical Layout */}
        <Grid container spacing={4} direction="column" alignItems="center">
          {testimonials.map((testimonial, index) => (
            <Grid item xs={12} sm={8} md={6} key={index}>
              <Box
                sx={{
                  backgroundColor: "#1C1C1C",
                  padding: "30px",
                  borderRadius: "10px",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)",
                  textAlign: "left",
                  color: "#FFFFFF",
                  maxWidth: "600px",
                  margin: "0 auto",
                }}
              >
                {/* Name */}
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    fontFamily: "'Poppins', sans-serif",
                    marginBottom: "8px",
                  }}
                >
                  {testimonial.name}
                </Typography>

                {/* Designation */}
                <Typography
                  variant="body1"
                  sx={{
                    color: "#8BC34A",
                    fontWeight: "bold",
                    fontFamily: "'Poppins', sans-serif",
                    marginBottom: "12px",
                  }}
                >
                  {testimonial.designation}
                </Typography>

                {/* Feedback */}
                <Typography
                  variant="body2"
                  sx={{
                    color: "#FFFFFF",
                    fontFamily: "'Poppins', sans-serif",
                    fontStyle: "italic",
                  }}
                >
                  "{testimonial.feedback}"
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </div>
  );
};

export default Testimonial;
